import { useEffect, useState } from "react";
import "./SiteSummary.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { authFetch } from "../utils/authFetch";

function SiteSummaryPage() {
  const [sites, setSites] = useState([]);
  const [selectedPOs, setSelectedPOs] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [openSiteId, setOpenSiteId] = useState(null);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  }).format(Math.round(amount));
};

  const exportExcel = () => {
  const formatted = sites.map(s => ({
    Site: s.site_name,
    Location: s.location,
    Total: s.total_amount,
    "PO Count": s.po_count
  }));
  

  const ws = XLSX.utils.json_to_sheet(formatted);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Site Summary");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

  saveAs(blob, "Site_Summary.xlsx");
};

  const loadSites = async () => {
  let url =
`${process.env.REACT_APP_API_URL}/site-summary?from=${from}&to=${to}`;

  const res = await authFetch(url);
  const data = await res.json();
  setSites(data);
};

  useEffect(() => {
    loadSites();
  }, []);

  const handleView = async (site) => {

  // CLOSE IF SAME SITE CLICKED

  if (openSiteId === site.id) {

    setOpenSiteId(null);

    setSelectedPOs([]);

    setSelectedSite("");

    return;

  }
  // OPEN
  const res = await authFetch(
    `${process.env.REACT_APP_API_URL}/site-pos/${site.id}`
  );

  const data = await res.json();

  setSelectedPOs(data);

  setSelectedSite(site.site_name);

  setOpenSiteId(site.id);

};

  // 🔢 CALCULATIONS
  const totalSpend = sites.reduce((sum, s) => sum + Number(s.total_amount), 0);
  const topSite = sites.length
  ? sites.reduce((max, s) =>
      Number(s.total_amount) > Number(max.total_amount) ? s : max
    )
  : {};

  return (
    <div className="summary-container">
      <h2>Site Summary</h2>
      <div className="filter-bar">
  <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
  <input type="date" value={to} onChange={(e) => setTo(e.target.value)} />

  <button onClick={loadSites}>Filter</button>
  <button onClick={exportExcel}>Export Excel</button>
</div>

      {/* 🔹 CARDS */}
      <div className="cards">
        <div className="card">
          <h4>Total Sites</h4>
          <p>{sites.length}</p>
        </div>

        <div className="card">
          <h4>Total Spend</h4>
          <p>₹ {formatCurrency(totalSpend)}</p>
        </div>

        <div className="card">
          <h4>Top Site</h4>
          <p>{topSite?.site_name || "-"}</p>
        </div>
      </div>

      {/* 🔹 TABLE */}
      <div className="table-box">
        <table>
          <thead>
            <tr>
              <th>Site</th>
              <th>Location</th>
              <th>Total Amount</th>
              <th>PO Count</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {sites.map((s) => (
              <tr key={s.id}>
                <td>{s.site_name}</td>
                <td>{s.location}</td>
                <td>₹ {formatCurrency(s.total_amount)}</td>
                <td>{s.po_count}</td>
                <td>
                  <button onClick={() => handleView(s)}>

  {openSiteId === s.id
    ? "Close"
    : "View"}

</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 🔹 PO LIST */}
      {selectedPOs.length > 0 && (
        <div className="po-box">
          <h3>POs for: {selectedSite}</h3>

          <table>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Vendor</th>
                <th>Amount</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {selectedPOs.map((p) => (
                <tr key={p.id}>
                  <td>{p.order_id}</td>
                  <td>{p.vendor_name}</td>
                  <td>₹ {formatCurrency(p.total_amount)}</td>
                  <td>{p.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default SiteSummaryPage;